module.exports = __webpack_public_path__ + "e506502ba8c3618f0bfe819da927cbe7.MP3";